import type { Holder, KycCase, RiskRating } from '../../data/types';
import { addMonths } from '../../lib/format';

export interface RiskSuggestion {
  rating: RiskRating;
  factors: string[];
}

const REVIEW_MONTHS: Record<RiskRating, number> = { HIGH: 12, MEDIUM: 24, LOW: 36 };

export function nextReviewDate(rating: RiskRating, from: string): string {
  return addMonths(from, REVIEW_MONTHS[rating]);
}

export function suggestRisk(holder: Holder, cases: KycCase[], invested: number): RiskSuggestion {
  const high: string[] = [];
  const medium: string[] = [];
  const open = cases.filter((item) => item.holderId === holder.id && item.status !== 'CLEARED');
  if (holder.pep || holder.beneficialOwners.some((owner) => owner.pep))
    high.push('Politically exposed person');
  if (open.some((item) => item.type === 'SANCTIONS_POTENTIAL'))
    high.push('Open sanctions potential match');
  if (open.some((item) => item.type === 'ADVERSE_MEDIA')) medium.push('Adverse media under review');
  if (holder.residency !== 'AU')
    medium.push(`Tax resident outside Australia (${holder.residency})`);
  const controllers = holder.beneficialOwners.filter((owner) => owner.role !== 'BENEFICIARY');
  if (holder.type !== 'INDIVIDUAL' && controllers.length >= 3)
    medium.push('Ownership structure with three or more controllers');
  if (invested > 1_000_000) medium.push('Investment over $1m');
  const rating: RiskRating =
    high.length || medium.length >= 3 ? 'HIGH' : medium.length ? 'MEDIUM' : 'LOW';
  const factors = [...high, ...medium];
  return {
    rating,
    factors: factors.length ? factors : ['Australian resident, verified, simple structure'],
  };
}
